import { Deserializable } from '../protocols/deserializable';
import { RemittanceSource } from './remittance-source';
import { Attachment } from '../submissions/attachment';
import { BaseType } from '../base/base-type';
import { PortalType } from '../enum/shared/portal-type';

export abstract class BaseRemittance implements Deserializable {
  public id!: number;
  public employerId!: number;
  public employerName!: string;
  public statusId!: number;
  public sourceId!: number;
  public source!: RemittanceSource;
  public status!: BaseType;
  public submittedDate!: string | null;
  public taxationYear!: string | null;
  public totalRemittanceAmount!: number | null;
  public contributionCount!: number | null;
  public contributionEntryCount!: number | null;
  public attachmentForUpload!: Attachment | null;
  public lastUpdatedDate!: string;
  public lastStatusUpdateDate!: string;

  public abstract contributionEntriesAreEditable(portal?: PortalType): boolean;

  // Not From API
  public displayableId!: string;

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (this.source) Deserialize?.instanceOf(RemittanceSource, this.source);
    if (this.status) Deserialize?.instanceOf(BaseType, this.status);
    if (this.attachmentForUpload) Deserialize?.instanceOf(Attachment, this.attachmentForUpload);
    this.displayableId = this.id.toString().padStart(8, '0');
  }
}
